import { toast } from "react-toastify";
import { BASE_URL } from "../../../global";
import axiosWithToken from "../../../utils/components/axiosTokenConfig";
import moment from "moment";
import compareOldAndNewReadings from "../../../utils/components/compareoldandnewReadings";

const refresh = () => {
  window.location.reload(false);
};

export const onSubmit = (
  params,
  state,
  accreditationType,
  selectedDateRange,
  delteRangesID,
  commonUncertaintyFactors
) => {
  let standardMasterIdArray = [];
  (state.standardMasterIdArray || "").split("|").forEach((element, index) => {
    standardMasterIdArray = [
      ...standardMasterIdArray,
      String(element.split(":")[0]),
    ];
  });
  standardMasterIdArray = standardMasterIdArray.join(",");

  let url = BASE_URL;
  var jsonData = {
    disciplineId: state.disciplineValue.id,
    instrumentName: state.instrumentNameId,
    standardMasterIds: standardMasterIdArray,
    calibrationProcedureNo: state.calibrationProcedureNo,
    multipleCalibrationProcedureNo: state.multipleCalibrationProcedureNo.length > 0 ?  JSON.stringify(state.multipleCalibrationProcedureNo) : null,
    referenceStandards: state.referenceStandards,
    tablePartition: state.tablePartition,
    formatNumber: state.formatNumber,
    revisionNumber: state.revisionNumber,
    remarkId: state.remarkId,
    accreditationType: accreditationType,
    commonUncertaintyFactors: commonUncertaintyFactors?.join(","),
    revisionDate: state.revisionDate
      ? moment(state.revisionDate).format("YYYY-MM-DD")
      : null,
    sopUpload: state.sopUpload || null,
    uncertaintyFactors: state.standardMasterIdArray,
    // supportiveInstrumentMasterData: (state.supportiveIds || [])
    //   .map((e) => `${e.id}:${e.standardRangesId}`)
    //   .join(","),
    isGauge: state.updateEnableDisableO ? state.updateEnableDisableO.id : null,
    datasheetFormatNumber: state.datasheetFormatNumber,
    DatasheetRevisionNumber: state.DatasheetRevisionNumber,
    DatasheetRevisionDate: state.DatasheetRevisionDate
      ? moment(state.DatasheetRevisionDate).format("YYYY-MM-DD")
      : null,
    calMethod: state?.calMethod?.label ? state?.calMethod?.label : null, 
  };

  if (params.id)
    axiosWithToken
      .patch(url + `instruments/${params.id}`, jsonData)
      .then((res) => {
        submitRanges(
          params.id,
          params,
          state,
          accreditationType,
          selectedDateRange,
          delteRangesID
        );
      })
      .catch((err) => {
        console.log("Error in instrument patch: ", err);
      });
  else
    axiosWithToken
      .post(url + "instruments", jsonData)
      .then((res) => {
        submitRanges(
          res.data.insertId,
          params,
          state,
          accreditationType,
          selectedDateRange,
          delteRangesID
        );
      })
      .catch((err) => {
        console.log("Error in instrument post: ", err);
      });
};

const submitRanges = (
  id,
  params,
  state,
  accreditationType,
  selectedDateRange,
  delteRangesID
) => {
  if (delteRangesID.length > 0) {
    axiosWithToken
      .post(BASE_URL + "dynamic", {
        query: `DELETE FROM cmc WHERE id IN (${delteRangesID});`,
      })
      .then((res) => {
        console.log("cmc deleted succesfully!", res);
      })
      .catch((err) => console.log("cmc deleted error : ", err));
  }

  if (state.readingRows.length) {
    let rows = state.readingRows.map((row, i) => ({
      instrumentId: Number(id),
      accreditationType: accreditationType,
      fromDate: selectedDateRange?.selectedFrom
        ? selectedDateRange?.selectedFrom
        : row[11],
      toDate: selectedDateRange?.selectedTo
        ? selectedDateRange?.selectedTo
        : row[12],
      mode:
        state.readingRangeValue[i][1] && row[1]
          ? row[1] + "#" + state.readingRangeValue[i][1]
          : row[1]
          ? row[1]
          : null,
      etParameter:
        state.readingRangeValue[i][2] && row[2]
          ? row[2] + "#" + state.readingRangeValue[i][2]
          : row[2]
          ? row[2]
          : null,
      paratype:
        state.readingRangeValue[i][3] && row[3]
          ? row[3] + "#" + state.readingRangeValue[i][3]
          : row[3]
          ? row[3]
          : null,
      fromRange:
        state.readingRangeValue[i][4] && row[4]
          ? row[4] + "#" + state.readingRangeValue[i][4]
          : row[4]
          ? row[4]
          : null,
      toRange:
        state.readingRangeValue[i][5] && row[5]
          ? row[5] + "#" + state.readingRangeValue[i][5]
          : row[5]
          ? row[5]
          : null,
      parameter:
        state.readingRangeValue[i][6] && row[6]
          ? row[6] + "#" + state.readingRangeValue[i][6]
          : row[6]
          ? row[6]
          : null,
      lowerCmc:
        state.readingRangeValue[i][7] && row[7]
          ? row[7] + "#" + state.readingRangeValue[i][7]
          : row[7]
          ? row[7]
          : null,
      higherCmc:
        state.readingRangeValue[i][8] && row[8]
          ? row[8] + "#" + state.readingRangeValue[i][8]
          : row[8]
          ? row[8]
          : null,
      location: state.readingRangeValue[i][9] && row[9] ? row[9] : row[9] || 1,
      lc:
        state.readingRangeValue[i][10] && row[10]
          ? row[10] + "#" + state.readingRangeValue[i][10]
          : row[10]
          ? row[10]
          : null,
    }));
    let post = [],
      postIndexes = [],
      patch = [];
    rows.map((r, i) => {
      if (state.readingRows[i][0] === "") {
        post.push(r);
        postIndexes.push(i);
      } else {
        patch.push([state.readingRows[i][0], r]);
        postIndexes.push(undefined);
      }
    });

    var parsedData = JSON.parse(sessionStorage.getItem("cmcReadings")) || [];
    // const cleanedParsedData = parsedData.map(({ ...rest }) => rest);
    const transformedData = patch?.map(([id, obj]) => ({ id, ...obj }));
    const cleanedParsedData = parsedData?.map((item) => ({
      ...item,
      fromDate: moment(item.fromDate).format("YYYY-MM-DD"),
      toDate: moment(item.toDate).format("YYYY-MM-DD"),
    }));

    const newStandardRangesId = compareOldAndNewReadings(
      cleanedParsedData,
      transformedData
    );
    patch = patch?.filter(([id]) => newStandardRangesId.includes(id));
    console.log({ patch, cleanedParsedData, transformedData });
    Promise.all(
      (post.length > 0
        ? [axiosWithToken.post(BASE_URL + "cmc/bulk", post)]
        : []
      ).concat(
        patch.length > 0
          ? [
              ...patch.map((p) =>
                axiosWithToken.patch(BASE_URL + `cmc/${p[0]}`, p[1])
              ),
            ]
          : []
      )
    )
      .then((res) => {
        if (params.id === undefined) {
          toast.success("Instrument Created Successfully!");
        } else if (post.length > 0) {
          toast.success("Instrument Updated Successfully!");
          let newRows = [...state.readingRows];
          let idx = 0;
          postIndexes.map((i) => {
            if (i !== undefined) {
              newRows[i].id = res[idx];
              idx += 1;
            }
          });
        } else {
          toast.success("Instrument Updated Successfully!");
        }
      })
      .catch((err) => {
        console.log("Error in cmc post/patch: ", err);
      });
  } else if (params.id !== undefined) {
    refresh();
  }

  setTimeout(() => {
    refresh();
  }, 1000);
};
